<template>
  <div class="login">
      <v-container class="container-div">
          <v-layout row wrap>

							<v-flex xs12 sm12 md5 class="container-first-div hidden-sm-and-down">
											<div class="div-logo-magafilio-desktop" >
														<img
															src="../assets/logo_magafilio_branco.svg"
															alt="Logo Magafilio"
															class="logo-magafilio-desktop"
														/>
											</div>
											<div class="div-paragrafo-logo">
												<p>
													A Magafilio ajuda você a se conectar com várias lojas e conquistar
													uma <strong><i>renda</i></strong> sem sair de casa.
												</p>
											</div>
							</v-flex>

							<v-flex xs11 sm8 md5 class="ma-auto">
									<div v-if="show_flag_admin">
											<v-checkbox
													class="text-xs-center"
													auto-height="false"
													v-model="flag_admin"
											></v-checkbox>
									</div>

									<div v-else class="text-xs-right">
											<button class="container-button-admin" v-on:click="show_flag_admin = true">admin</button>
									</div>

									<v-card elevation="15" color="#2D2F32" class="container-card">
														<!-- Esconde no Desktop -->
												<div class="div-logo-magafilio-mobile hidden-md-and-up" >
															<img
																src="../assets/logo_magafilio_branco.svg"
																alt="Logo Magafilio"
															/>
												</div>
												<v-form
														ref="form"
														v-model="valid"
														@submit.prevent="login"
														lazy-validation
														class="formulario-login"
												>
														<v-text-field
																v-model="email"
																:rules="emailRules"
																key="email"
																label="E-mail"
																class="container-input"
																required
																outline
														></v-text-field>
														<v-text-field
																v-model="passwd"
																key="password"
																:rules="passwdRules"
																label="Senha"
																:append-icon="show ? 'visibility' : 'visibility_off'"
																:type="show ? 'text' : 'password'"
																@click:append="show = !show"
																required
																outline
														></v-text-field>
														<button
															:disabled="!valid || email.length == 0 || passwd.length == 0"
															color="#2D2F32"
															class="button-sign"
															type="submit"
															>
															ENTRAR
													</button>
												</v-form>
												<div class=container-forgotPassword>
														<router-link class="hyperlinkForgot" to="/forgot_login">
																Esqueceu sua senha?
														</router-link>
												</div>
									</v-card>

									<div class="container-signUp">
											<router-link class="hyperlinkCreateCount" to="/login/solicitacao">
													Cadastre-se
											</router-link>
									</div>
									<div class="line" />

									<div>
										<p class="paragrafo">
											Ao utilizar a plataforma você declara estar de acordo com
											os nossos
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<a
														v-bind="attrs"
														v-on="on"
														class="container-UseTerms"
														href="https://magafilio-public.s3-sa-east-1.amazonaws.com/termos-de-uso.pdf"
														target="_blank"
													>
														Termos de Uso
													</a>
												</template>
												<span>Clique para abrir o documento</span>
											</v-tooltip>
										</p>
									</div>

						</v-flex>
        </v-layout>
    </v-container>
  </div>
</template>

<script>
import { affiliate_api } from '@/api'

export default {
	mixins: [affiliate_api],
	data () {
		return {
			show: false,
			show_flag_admin: false,
			flag_admin: false,
			valid: true,
			advertiser: undefined,
			advertiserId: undefined,
			advertiserList: [],
			advertiserName: '',
			email: '',
			passwd: '',
			passwdRules: [(v) => !!v || 'Senha obrigatória'],
			emailRules: [
				(v) => !!v || 'E-mail obrigatório',
				(v) => /.+@.+/.test(v) || 'E-mail precisa ser válido',
			],
		}
	},
	methods: {
		login: async function () {
			if (!this.$refs.form.validate()) return

			try {

				let aff = await this.get_affiliate(
					this.email.trim(),
					this.passwd,
					this.flag_admin
				)

				localStorage.mgf_login = this.email.trim()
				localStorage.mgf_password = this.passwd

				let adv = await this.get_aff_adv_list(localStorage.mgf_login)
				this.$root.affiliate = aff.data
				this.$root.advertiserList = adv.data
				var useTour = await this.get_guide_tour(aff.data.magauser)
				localStorage.setItem('guide_tour', useTour)
				localStorage.setItem('magauser', aff.data.magauser)
				localStorage.setItem('affiliate', JSON.stringify(aff.data))
				localStorage.setItem('advertiserList', JSON.stringify(adv.data))
				this.$router.replace('/home')

			} catch (err) {

				this.$notify({
					type: 'error',
					title: 'Email ou senha inválidos',
				})

			}
		},
		buttonPressioned: async function () {
			this.$root.affiliate = {}
			this.$root.advertiserList = []

			//this.$refs.form.reset();
			//document.location.reload(true); // Recarrega a página atual sem usar o cache
		},
	}

}
</script>

<style>

div.container {
    padding: 0;
}

div.login{
		width: 100%;
    height: 100vh;
}

div.container-div {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.container-card .div-logo-magafilio-mobile {
	display: flex;
	align-items: center;
	justify-content: center;
}

.container-card .div-logo-magafilio-mobile img {
	width: 50%;
}

.container-first-div {
	padding-top: 50px;
}

.container-first-div .div-logo-magafilio-desktop img.logo-magafilio-desktop {
    width: 230px;
}

.container-first-div .div-paragrafo-logo {
	padding-top: 15px;
	margin: auto;
}

.container-first-div .div-paragrafo-logo p {
	font-size: 18px;
	line-height: 28px;
	font-weight: 300;
}

.container-first-div .div-paragrafo-logo p strong {
	font-weight: 900;
	text-decoration: underline;
}

.formulario-login {
	margin-top: 10px;
}

.container-card {
    padding: 14px 14px 16px 14px;
		box-shadow: 9px 9px 16px rgba(0, 0, 0, 0.25), -9px -9px 16px rgba(74, 74, 74, 0.25);
		border-radius: 23px;
		margin-bottom: 40px;
}

.elevation-15 {
    box-shadow: 9px 9px 16px rgba(0, 0, 0, 0.25), -9px -9px 16px rgba(74, 74, 74, 0.25) !important;
}

div.v-messages{
    min-height: 0px;
}

.container-input {
    padding: 14px 16px;
}

.v-input__slot {
	box-shadow: inset -3px -3px 4px rgba(74, 74, 74, 0.25), inset 5px 5px 4px rgba(0, 0, 0, 0.25) !important;
	border-radius: 65px !important;
	min-height: auto !important;
}

.v-text-field__slot {
	height: 40px;
	margin: 4px;
}

.v-text-field--box .v-label, .v-text-field--full-width .v-label, .v-text-field--outline .v-label {
    top: 11px;
}

.v-text-field.v-text-field--enclosed .v-input__prepend-outer, .v-text-field.v-text-field--enclosed .v-input__prepend-inner, .v-text-field.v-text-field--enclosed .v-input__append-inner, .v-text-field.v-text-field--enclosed .v-input__append-outer {
    margin-top: 12px !important;
}

.v-label.theme--light, .v-icon.v-icon--link.material-icons.theme--light {
	color: #c6c6c6
}

.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
	border: 0 !important;
}

button.button-sign {
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 10px auto 0px auto;
    width: 60%;
    font-size: 16px;
		font-weight: bold;
		box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.25), -3px -3px 8px rgba(74, 74, 74, 0.25) !important;
		border-radius: 23px;
		color: #64D97E !important;
		border: 1px solid #64D97E;
}

button.button-sign:hover {
	opacity: 0.6;
}

button.button-sign:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

/* .v-btn__content {
	color: #64D97E !important;
} */


.hyperlinkForgot {
	font-size: 14px;
  font-weight: 400;
  margin: auto;
	color:#64D97E;
}

div.container-forgotPassword {
    padding-top: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
		text-decoration: underline;
}

.line {
    align-items: center;
		border: 1px solid #454545;
    display: flex;
    margin: 25px 16px;
    text-align: center;
}

div.container-signUp {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    width: 60%;
		height: 40px;
		background: linear-gradient(90deg, #E0E5EC -9.54%, #60AF68 -9.53%, #1B9569 109.16%);
		box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.5), -3px -3px 8px rgba(74, 74, 74, 0.5);
		border-radius: 23px;
    transition: background-color 0.2s;
}

.hyperlinkCreateCount {
    text-decoration: none;
    color: #FFFFFF !important;
    font-size: 17px;
    font-weight: 400;
		line-height: 18px;
    padding: 15px;
    flex: 1;
    text-align: center;
}

div.container-signUp:hover{
    background-color: rgba(0,0,0,0.9);
}

p.paragrafo {
	margin: 0px 16px;
	font-size: 12px;
  text-align: center;
}

a.container-UseTerms {
    color: #64D97E !important;
}

button.container-button-admin {
    margin: 0px;
    margin-bottom: 0px;
    color: #2D2F32 !important;
}

/* Begin input */
.formulario-login .v-text-field__slot {
	margin: 0px;
}

.formulario-login .v-input__icon.v-input__icon--append .v-icon.v-icon--link.material-icons.theme--light {
	margin-bottom: 7px;
}

.formulario-login .v-label.v-label--active.theme--light.primary--text,
.formulario-login .v-input__icon.v-input__icon--append .v-icon.v-icon--link.material-icons.theme--light.primary--text
{
	color: #40DA99 !important;
}

.formulario-login .theme--light.v-input:not(.v-input--is-disabled) input {
	padding-bottom: 20px;
}

/* End input */

</style>
